import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ui/ConfirmDialog';

interface ConfirmDeleteModalProps {
  title: string;
  itemName: string;
  description?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

/**
 * Kept for existing callers; renders `ui/ConfirmDialog` (T-27) as a
 * destructive confirm that names the object, with "ביטול" focused first.
 */
export default function ConfirmDeleteModal({ title, itemName, description, onConfirm, onCancel, loading = false }: ConfirmDeleteModalProps) {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      title={title}
      description={t('common.confirmDeleteItem', { name: itemName })}
      confirmLabel={loading ? t('common.deleting') : t('common.delete')}
      onConfirm={onConfirm}
      onCancel={onCancel}
      danger
      loading={loading}
    >
      {description && (
        <div className="rounded-lg bg-warning-50 p-3">
          <p className="mb-1 text-xs font-semibold text-warning-800">{t('common.attention')}</p>
          <p className="text-xs text-warning-800">{description}</p>
        </div>
      )}
    </ConfirmDialog>
  );
}
